module.exports = __webpack_public_path__ + "img/personal_info-1.7a0b4bed.jpg";